// The shared player is unmounted while a live page is open and rebuilt when the
// listener leaves it. A rebuilt player must not start the song by itself: the
// listener may have paused it, and a song that was playing stopped when the
// player went away. Only a song the listener has just picked plays at once.

let lastShownQueue = null;

/** Record the queue a player is showing, so a later rebuild can recognise it. */
export function rememberShownQueue(queue) {
  lastShownQueue = queue;
}

/**
 * The song a newly mounted player should show without playing: the current
 * song when the queue is the one a previous player showed, otherwise null (a
 * new pick, which plays).
 */
export function songToWaitOn(queue, songIndex) {
  if (!queue || queue !== lastShownQueue) return null;
  return queue[songIndex]?._id ?? null;
}
